import { StorageBaseService, StorageType } from './storage-base.service';

export class LocalStorage extends StorageBaseService {
  static override type = StorageType.Local;
}
